//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { getClientInstagramFeatures } from '@account-settings/redux/facebook-instagram/selectors/getFbIgFeatures';

export const getHasFbIgAutoPostingFeature = createSelector(
  getClientInstagramFeatures,
  (clientInstagramFeatures) => !!clientInstagramFeatures.InstagramAutoPosting,
);
